/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Legal_AcknowledgeInputs */



/**
* | output |
* | --- |
* | "By subscribing, you agree to our:" |
*
* @param {Pricing_Legal_AcknowledgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_legal_acknowledge = /** @type {((inputs?: Pricing_Legal_AcknowledgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Legal_AcknowledgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Ihrem Abonnement akzeptieren Sie:")
	return /** @type {LocalizedString} */ ("By subscribing, you agree to our:")
});